import DYPoint from './lib/common/DYPoint';
import DYBrowser from './lib/common/base';

const dyPoint = new DYPoint('page_zht_actives');

class Ponits {
    // 初始化_页面专题_活动页
    static init_page_zht_actives () {
        dyPoint.sub('init_page_zht_actives', {
            is_app: (DYBrowser.isDyAndroid || DYBrowser.isDyIOS) ? 1 : 0,
            zhtname: '签到页'
        });
    }

    // 点击_鱼丸活动_分享页_报名
    static click_ywact_share_signup () {
        dyPoint.sub('click_ywact_share_signup', {
            is_app: (DYBrowser.isDyAndroid || DYBrowser.isDyIOS) ? 1 : 0,
            zhtname: '签到页'
        });
    }
}

export default Ponits;
